import styled from 'styled-components'

export const AppWrapper = styled.div`
    background: black;
    width: 93.31%;
    height: 93.5vh;
    color: white;
    padding: 2rem 4rem;
`

export const HeaderWrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;

    span {
        margin: 10px 0;
        font-size: 30px;
        font-weight: 400;
    }
`

export const LogoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`
